module.exports = __webpack_public_path__ + "0d015faeae62877dd1faa40007623cb3.png";